import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const CitySelection = () => {
    const [selectedCity, setSelectedCity] = useState(null);
    const [isVisible, setIsVisible] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        setIsVisible(true);
    }, []);

    const cities = [
        {
            id: 'montreal',
            name: 'Montreal',
            country: 'Canada',
            description: 'European charm, vibrant arts',
            tags: ['Museums', 'Old Port', '758 spots'],
            image: 'https://aebc975c.delivery.rocketcdn.me/wp-content/uploads/2021/12/marc-olivier-jodoin-BG9oZ15a4Xk-unsplash-1-scaled.jpg.webp',
            popular: true
        },
        {
            id: 'newyork',
            name: 'New York',
            country: 'USA',
            description: 'The city that never sleeps',
            tags: ['Broadway', 'Times Square', 'Nightlife'],
            image: 'https://nyc.eu/wp-content/uploads/2015/07/New_York_City-scaled.jpg',
            popular: true
        },
        {
            id: 'toronto',
            name: 'Toronto',
            country: 'Canada',
            description: 'Multicultural metropolis',
            tags: ['CN Tower', 'Islands', 'Diverse Food'],
            image: 'https://media.nomadicmatt.com/torontoguide.jpg'
        },
        {
            id: 'lasvegas',
            name: 'Las Vegas',
            country: 'USA',
            description: 'Entertainment capital',
            tags: ['Shows', 'Casinos', 'Nightlife'],
            image: 'https://static01.nyt.com/images/2023/04/13/multimedia/13hours-LasVegas-03-zjkm/13hours-LasVegas-03-zjkm-superJumbo.jpg'
        }
    ];

    const handleCitySelect = (cityId) => {
        setSelectedCity(cityId);
        setTimeout(() => {
            navigate('/features', {
                state: {
                    selectedCity: cityId
                }
            });
        }, 300);
    };

    const handleBack = () => {
        navigate('/');
    };

    return (
        <>
            <style>{`
        .city-selection-container {
          width: 100%;
          max-width: 430px;
          height: 100vh;
          height: 100dvh;
          margin: 0 auto;
          background: #f5f5f7;
          display: flex;
          flex-direction: column;
          position: relative;
          overflow: hidden;
        }
        
        @media (min-width: 430px) {
          .city-selection-container {
            border-radius: 24px;
            box-shadow: 0 10px 40px rgba(0,0,0,0.1);
          }
        }
        
        /* Header */
        .city-header {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
          padding: 20px;
          padding-top: 50px;
          box-shadow: 0 1px 0 rgba(0, 0, 0, 0.05);
        }
        
        .header-content {
          display: flex;
          align-items: center;
          gap: 12px;
        }
        
        .back-btn {
          width: 32px;
          height: 32px;
          border-radius: 10px;
          background: transparent;
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.2s;
        }
        
        .back-btn:hover {
          background: rgba(0, 0, 0, 0.05);
        }
        
        .header-text h1 {
          font-size: 17px;
          font-weight: 600;
          color: #1a1a1a;
          margin: 0;
          letter-spacing: -0.3px;
        }
        
        .header-text p {
          font-size: 12px;
          color: #8e8e93;
          margin: 2px 0 0 0;
        }
        
        /* Search Bar */
        .search-container {
          padding: 0 20px 16px;
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
        }
        
        .search-bar {
          position: relative;
        }
        
        .search-input {
          width: 100%;
          padding: 10px 16px 10px 40px;
          background: #f0f0f2;
          border: none;
          border-radius: 12px;
          font-size: 14px;
          outline: none;
          transition: all 0.2s;
        }
        
        .search-input::placeholder {
          color: #8e8e93;
        }
        
        .search-input:focus {
          background: #e8e8ea;
        }
        
        .search-icon {
          position: absolute;
          left: 12px;
          top: 50%;
          transform: translateY(-50%);
          color: #8e8e93;
        }
        
        .city-count {
          text-align: center;
          padding: 8px;
          font-size: 13px;
          color: #8e8e93;
          background: rgba(255, 255, 255, 0.95);
        }
        
        /* Content */
        .city-content {
          flex: 1;
          overflow-y: auto;
          padding: 16px;
          -webkit-overflow-scrolling: touch;
        }
        
        /* City Cards */
        .city-card {
          background: white;
          border-radius: 20px;
          margin-bottom: 16px;
          overflow: hidden;
          cursor: pointer;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          opacity: 0;
          transform: translateY(20px);
          animation: slideUp 0.5s ease forwards;
          box-shadow: 0 2px 8px rgba(0,0,0,0.06);
        }
        
        .city-card:nth-child(1) { animation-delay: 0.1s; }
        .city-card:nth-child(2) { animation-delay: 0.15s; }
        .city-card:nth-child(3) { animation-delay: 0.2s; }
        .city-card:nth-child(4) { animation-delay: 0.25s; }
        
        @keyframes slideUp {
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .city-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 24px rgba(0,0,0,0.12);
        }
        
        .city-card.selected {
          box-shadow: 0 8px 24px rgba(0,0,0,0.15);
        }
        
        .city-image-container {
          position: relative;
          width: 100%;
          height: 200px;
          overflow: hidden;
        }
        
        .city-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          transition: transform 0.3s ease;
        }
        
        .city-card:hover .city-image {
          transform: scale(1.05);
        }
        
        .image-overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 120px;
          background: linear-gradient(to top, rgba(0,0,0,0.7), transparent);
          pointer-events: none;
        }
        
        .city-image-info {
          position: absolute;
          bottom: 12px;
          left: 16px;
          right: 16px;
          color: white;
          z-index: 1;
        }
        
        .city-name-overlay {
          font-size: 22px;
          font-weight: 600;
          margin-bottom: 4px;
          letter-spacing: -0.5px;
        }
        
        .city-desc-overlay {
          font-size: 13px;
          opacity: 0.9;
        }
        
        .favorite-btn {
          position: absolute;
          top: 12px;
          right: 12px;
          width: 32px;
          height: 32px;
          background: rgba(255, 255, 255, 0.2);
          backdrop-filter: blur(10px);
          -webkit-backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.3);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.2s;
        }
        
        .favorite-btn:hover {
          background: rgba(255, 255, 255, 0.3);
          transform: scale(1.1);
        }
        
        .city-info {
          padding: 16px;
        }
        
        .city-location-row {
          display: flex;
          align-items: center;
          gap: 6px;
          color: #8e8e93;
          font-size: 13px;
          margin-bottom: 12px;
        }
        
        .city-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 6px;
          margin-bottom: 16px;
        }
        
        .city-tag {
          padding: 6px 12px;
          background: #f5f5f7;
          border-radius: 10px;
          font-size: 12px;
          color: #1a1a1a;
          font-weight: 500;
        }
        
        .popular-badge {
          position: absolute;
          top: 12px;
          left: 12px;
          padding: 4px 10px;
          background: #1a1a1a;
          color: white;
          border-radius: 8px;
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.5px;
        }
        
        .explore-btn {
          width: 100%;
          padding: 12px;
          background: #1a1a1a;
          color: white;
          border: none;
          border-radius: 12px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s;
        }
        
        .explore-btn:hover {
          background: #000;
          transform: translateY(-1px);
        }
        
        .explore-btn:active {
          transform: translateY(0);
        }
      `}</style>

            <div className="city-selection-container">
                <div className="city-header">
                    <div className="header-content">
                        <button className="back-btn" onClick={handleBack}>
                            <i className="bi bi-chevron-left"></i>
                        </button>
                        <img
                            src="/assets/logocity.jpg"
                            alt="Logo"
                            style={{
                                width: '32px',
                                height: '32px',
                                objectFit: 'contain',
                                borderRadius: '8px'
                            }}
                        />
                        <div className="header-text">
                            <h1>Select a City</h1>
                            <p>Choose your destination to explore</p>
                        </div>
                    </div>
                </div>

                <div className="search-container">
                    <div className="search-bar">
                        <i className="bi bi-search search-icon"></i>
                        <input 
                            type="text" 
                            className="search-input" 
                            placeholder="Search cities..."
                        />
                    </div>
                </div>

                <div className="city-count">{cities.length} cities available</div>

                <div className="city-content">
                    {cities.map(city => (
                        <div
                            key={city.id}
                            className={`city-card ${selectedCity === city.id ? 'selected' : ''}`}
                            onClick={() => handleCitySelect(city.id)}
                        >
                            <div className="city-image-container">
                                <img
                                    src={city.image}
                                    alt={city.name}
                                    className="city-image"
                                />
                                <div className="image-overlay"></div>
                                
                                {city.popular && (
                                    <span className="popular-badge">POPULAR</span>
                                )}
                                
                                <button className="favorite-btn" onClick={(e) => e.stopPropagation()}>
                                    <i className="bi bi-heart" style={{ color: 'white', fontSize: '14px' }}></i>
                                </button>
                                
                                <div className="city-image-info">
                                    <div className="city-name-overlay">{city.name}</div>
                                    <div className="city-desc-overlay">{city.description}</div>
                                </div>
                            </div>
                            
                            <div className="city-info">
                                <div className="city-location-row">
                                    <i className="bi bi-geo-alt" style={{ fontSize: '12px' }}></i>
                                    <span>{city.country}</span>
                                </div>
                                
                                <div className="city-tags">
                                    {city.tags.map((tag, index) => (
                                        <span key={index} className="city-tag">{tag}</span>
                                    ))}
                                </div>
                                
                                <button 
                                    className="explore-btn"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleCitySelect(city.id);
                                    }}
                                >
                                    Explore {city.name}
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default CitySelection;